import { css } from "@compiled/react";
import { SortDefinition } from "src/uniform/contenttypes/sortDefinition";

import { token } from "@atlaskit/tokens";

export interface SortControlProps {
    readonly sorts: SortDefinition[];
    readonly selectedSortId: string | undefined;
    readonly onChange: (sortId: string) => void;
}

/**
 * Single-select widget that lets the user pick which `SortDefinition` to apply.
 * Renders nothing when there are no sorts to choose from.
 */
export const SortControl = ({
    sorts,
    selectedSortId,
    onChange
}: SortControlProps) => {
    if (sorts.length === 0) return null;

    return (
        <label css={sortControlStyle}>
            <span>Sort by</span>
            <select
                value={selectedSortId ?? ""}
                onChange={(event) => onChange(event.target.value)}
                css={sortSelectStyle}
            >
                <option value="">None</option>
                {sorts.map((sort) => (
                    <option key={sort.id} value={sort.id}>
                        {sort.label}
                    </option>
                ))}
            </select>
        </label>
    );
};

const sortControlStyle = css({
    display: "inline-flex",
    alignItems: "center",
    gap: token("space.100"),
    fontSize: "0.875rem"
});

const sortSelectStyle = css({
    border: `1px solid ${token("color.border")}`,
    borderRadius: "4px",
    padding: `${token("space.050")} ${token("space.100")}`,
    background: token("elevation.surface"),
    cursor: "pointer"
});
